import React from 'react';
import styled from 'styled-components';
import { Container, Store, Wrapper } from 'AppReact';
import { NavigationButton } from './atoms';
import device from "utils/device";
import { tabsArray as tabs } from './../../constants';


const containerTemplate = styled.div`
    display:flex; 
    justify-content: space-between; 
    align-items: center;
    width: 336px;
    padding: 0 24px;
    margin: 30px auto 30px auto;

    @media ${device.tablet} {
        width: 594px;
    }
`


const NavigationBar = Container({
  name: 'NavigationBar',
  props: { property: Store, selectedTabId: Store, tabs },
  renderIf: ( { selectedTabId }) => {
    const showNavbar = selectedTabId !== "landingPage" && selectedTabId !== "thankyouPage"
    return showNavbar
  },
  elements: [
    {
      wrapper: Wrapper(containerTemplate),
      name: 'Buttons',
      elements: [
        {
          component: NavigationButton,
          name: 'Previous',
          displayValue: () => "Previous",
          bindings: ({ selectedTabId, tabs }) => {
            const currentIndex = tabs.indexOf(selectedTabId);
            if (currentIndex !== 0) return ({ newTab: tabs[currentIndex - 1] })
            return ({ newTab: tabs[currentIndex] })
          },
          displayState: ({ selectedTabId, tabs }) => {
            const currentIndex = tabs.indexOf(selectedTabId);
            return { disabled: currentIndex === 0 }
          },
        },
        {
          component: NavigationButton,
          name: 'Next',
          displayValue: () => "Next",
          renderIf: ({selectedTabId}) => selectedTabId !== 'review',
          bindings: ({ selectedTabId, tabs }) => {
            const currentIndex = tabs.indexOf(selectedTabId);
            if (currentIndex < (tabs.length - 1)) return ({ newTab: tabs[currentIndex + 1] })
            return ({ newTab: tabs[currentIndex] })
          },
          displayState: ({ selectedTabId, tabs }) => {
            const currentIndex = tabs.indexOf(selectedTabId);
            return { disabled: !(currentIndex < (tabs.length - 1)) }
          },
        },
      ],
    },
  ]
})

export default NavigationBar;
